import { Pipe, PipeTransform } from '@angular/core';
import { RequestProvider } from '../providers/request';

@Pipe({
  name: 'userRequests'
})

export class UserRequestsPipe implements PipeTransform {

  constructor(
    private requestProvider: RequestProvider
  ) { }

  transform(value: string, clientId: string): any {
    return this.requestProvider.getUserRequests(value, clientId);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/user-requests.pipe.ts